import Vue from 'vue';
import { gsap, CSSRulePlugin } from 'gsap';

Vue.component('homepage-slider', {
    props: ['slides'],

    data() {
        return {
            // Third-party
            hammertime: null,

            currentIndex: 0,
            imageTransition: 'transition-inline-slider-top', //'transition-inline-slider-right',
            dateTransition: 'transition-inline-slider-top',

            nextClicked: false,
            timer: 0
        };
    },

    watch: {
        nextSlide(newSlide, oldSlide) {
            if (newSlide) {
                EventBus.$emit('next-slide-set');
            }
            // Vue.nextTick(() => {
            //     if (objectFitPolyfill !== undefined) {
            //         objectFitPolyfill();
            //     }
            // });
        }
    },

    mounted() {
        this.initHammerTime();
        this.play();
    },

    methods: {
        reset() {
            clearInterval(this.timer);
            this.play();
        },

        play() {
            this.timer = setInterval(() => {
                this.next();
            }, 6000);
        },

        next() {
            if (this.inTransition) {
                return;
            }

            this.imageTransition = 'transition-inline-slider-top';
            this.dateTransition = 'transition-inline-slider-top';
            this.inTransition = true;
            const nextIndex = this.currentIndex + 1;

            if (nextIndex > this.slides.length - 1) {
                this.currentIndex = 0;
                return;
            }

            this.currentIndex = nextIndex;
            this.nextClicked = true;

            gsap.to('.split-line__inner', {
                translateY: '-100%',
                duration: 0.5,
                stagger: 0.1
            });

            gsap.to('.slider-events-link__underline', {
                width: '0%',
                right: 0,
                left: 'auto',
                duration: 0.5
            });

            this.reset();
        },

        previous() {
            if (this.inTransition) {
                return;
            }

            this.imageTransition = 'transition-inline-slider-bottom';
            this.dateTransition = 'transition-inline-slider-bottom';
            this.inTransition = true;

            const previousIndex = this.currentIndex - 1;

            if (previousIndex < 0) {
                this.currentIndex = this.slides.length - 1;
                return;
            }

            this.currentIndex = previousIndex;

            this.nextClicked = false;

            gsap.fromTo(
                '.split-line__inner',
                { translateY: '0%' },
                { translateY: '100%', duration: 0.5, stagger: 0.1 }
            );

            gsap.to('.slider-events-link__underline', {
                width: '0%',
                left: 0,
                right: 'auto',
                duration: 0.5
            });

            this.reset();
        },

        afterEnter(el) {
            this.inTransition = false;
        },

        /**
         * Initialize Hammertime
         *
         * @return {void}
         */
        initHammerTime() {
            this.hammertime = new Hammer(this.$el, {});
            this.hammertime.get('swipe');

            this.hammertime.on('swipeleft', ev => {
                this.next();
            });

            this.hammertime.on('swiperight', ev => {
                this.previous();
            });
        },

        mouseoverReadmoreAnimation(e) {
            console.log('HOVEREN: ', e.currentTarget);
            gsap.to('.slider-events-link__underline', {
                width: '0%',
                left: '50%',
                duration: 0.3
            });
        },

        mouseleaveReadmoreAnimation(e) {
            gsap.to('.slider-events-link__underline', {
                width: '100%',
                left: 0,
                duration: 0.3
            });
        }
    },

    beforeDestroy() {
        this.hammertime.off('swipeleft');
        this.hammertime.off('swiperight');
        this.hammertime.destroy();
        this.hammertime = null;
        clearInterval(this.timer);
    }
});
